import { RootState } from "../store/store";
import { StatementBalance } from "../models/statements/statement-balance";
import { createSelector } from "@reduxjs/toolkit";
import { selectedAccountIdsSelector } from "./accounts";

export const statementBalanceSelector = (state: RootState): StatementBalance =>
  state.statementBalance.data;

export const selectedAccountPrrSelector = createSelector(
  [statementBalanceSelector, selectedAccountIdsSelector],
  (statementBalance, selectedAccountIds): number | undefined => {
    if (!statementBalance || !statementBalance.accountPrrs) {
      return undefined;
    }
    if (selectedAccountIds.length !== 1) {
      return undefined;
    }
    const accountIds = selectedAccountIds.map((id) => id.toString());
    const account = statementBalance.accountPrrs.find(
      (apr) => apr.accountId === accountIds[0]
    );
    return account ? account.prr : undefined;
  }
);
